import { supabase } from '../../lib/supabase';
import type { MediaSlotRow } from '../../lib/types';

export async function listSlots(): Promise<MediaSlotRow[]> {
  const { data, error } = await supabase.from('media_slots').select('slot, label, path, focal_x, focal_y, updated_at').order('slot', { ascending: true });
  if (error) throw error;
  return (data ?? []) as MediaSlotRow[];
}

export async function createSlot(slot: string, labelText: string): Promise<void> {
  const { error } = await supabase.from('media_slots').insert({ slot, label: labelText, updated_at: new Date().toISOString() });
  if (error) throw error;
}

export async function updateSlot(slot: string, patch: Partial<Pick<MediaSlotRow, 'path' | 'focal_x' | 'focal_y' | 'label'>>): Promise<void> {
  const { error } = await supabase
    .from('media_slots')
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('slot', slot);
  if (error) throw error;
}
